import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Sparkles, Check } from "lucide-react";
import { PILL } from "./shared";

export default function PlanTab({ biz, setBiz }) {
  const plan = biz.plan_30day || {};
  const [done, setDone] = useState(new Set(biz.tasks_done || []));
  const [regen, setRegen] = useState(false);

  const toggle = async (key) => {
    const newDone = new Set(done);
    if (newDone.has(key)) newDone.delete(key);
    else newDone.add(key);
    setDone(newDone);
    try { await api.post("/business/tasks/toggle", { key }); }
    catch { toast.error("Failed"); }
  };
  const regenerate = async () => {
    setRegen(true);
    try {
      const { data } = await api.post("/business/regenerate/plan");
      setBiz(data);
      setDone(new Set(data.tasks_done || []));
      toast.success("Regenerated");
    } catch { toast.error("Failed"); }
    setRegen(false);
  };

  const weeks = ["week1", "week2", "week3", "week4"];
  const total = weeks.reduce((acc, w) => acc + (plan[w]?.tasks?.length || 0), 0);
  const completed = done.size;

  return (
    <div>
      <div className="nb-card p-5 mb-6 flex items-center justify-between">
        <div>
          <div className="font-display text-2xl font-extrabold">Your 30-day plan</div>
          <div className="text-sm text-gray-600 mt-1" data-testid="plan-progress">{completed} / {total} tasks done</div>
        </div>
        <button onClick={regenerate} disabled={regen} className={`${PILL} bg-[#F5F0FF]`} data-testid="regen-plan-btn">
          {regen ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Regenerate
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {weeks.map((w, idx) => {
          const wk = plan[w] || {};
          return (
            <div key={w} className="nb-card p-5" data-testid={`week-${idx + 1}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-[#FF7F50] text-white border-2 border-black flex items-center justify-center font-extrabold">{idx + 1}</div>
                <div>
                  <div className="text-xs uppercase font-bold text-gray-600">Week {idx + 1}</div>
                  <div className="font-display text-lg font-extrabold">{wk.title}</div>
                </div>
              </div>
              <div className="space-y-2">
                {(wk.tasks || []).map((t, i) => {
                  const key = `${w}-${i}`;
                  const isDone = done.has(key);
                  return (
                    <button key={i} onClick={() => toggle(key)} data-testid={`task-${w}-${i}`}
                      className={`w-full flex items-start gap-3 p-3 border-2 border-black rounded-xl nb-press text-left ${isDone ? "bg-[#F0FFF4]" : "bg-white"}`}>
                      <div className={`mt-0.5 w-5 h-5 rounded border-2 border-black flex items-center justify-center shrink-0 ${isDone ? "bg-[#10B981]" : "bg-white"}`}>
                        {isDone && <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />}
                      </div>
                      <span className={`text-sm ${isDone ? "line-through text-gray-500" : ""}`}>{t}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
